export const themes = {
  dark: {
    theme: 'dark',
    primary: '#1f2632',
    secondary: '#E6E0E9',
    textColorPrimary: '#E6E0E9',
    textColorSecondary: '#181717',
    textColorPreviousPrimary: '#181717',
    previousPrimary: '#E6E0E9;',
    previousSecondary: '#E6E0E9'
  },
  light: {
    theme: 'light',
    primary: '#E6E0E9',
    secondary: '#E6E0E9',
    textColorPrimary: '#181717',
    textColorSecondary: '#181717',
    textColorPreviousPrimary: '#E6E0E9',
    previousPrimary: '#1f2632',
    previousSecondary: '#E6E0E9'
  },
  types: {
    normal: '#b7b6a3',
    fighting: '#c56d5b',
    flying: '#9aa7fa',
    poison: '#b76da3',
    ground: '#e2c469',
    rock: '#c5b678',
    bug: '#b7c43e',
    ghost: '#7d7cc0',
    steel: '#b7b6c0',
    fire: '#ff5f3e',
    water: '#51a7fa',
    grass: '#8bd369',
    electric: '#ffd34c',
    psychic: '#ff6da3',
    ice: '#7dd3fa',
    dragon: '#8b7ceb',
    dark: '#8b6d5b',
    fairy: '#f1a7ec'
  }
}
